import React, { useEffect, useRef, useState } from 'react';
import './Premium_services.css';
import { add_project, get_contractor } from '../../../utils/services';
import {  useNavigate } from 'react-router-dom';

function Premium_services  ({user_id, permission}) {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const modelInputRef = useRef(null);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState('asc');

  //LIST OF SERIAL MEMBERS:
  const [searchTerm, setSearchTerm] = useState('');
  const [contractors, setcontractors] = useState([]);





    // Función para manejar la búsqueda
    const filteredContractors = contractors.filter((contractor) =>
      contractor.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const sortTable = (column) => {
      const order = sortedColumn === column && sortOrder === 'asc' ? 'desc' : 'asc';
      setSortedColumn(column);
      setSortOrder(order);

      filteredContractors.sort((a, b) => {
        const valA = a[column];
        const valB = b[column];
    
        if (typeof valA === 'string' && typeof valB === 'string') {
          // Comparación alfabética
          return order === 'asc' 
            ? valA.localeCompare(valB) // orden ascendente
            : valB.localeCompare(valA); // orden descendente
        }
    
        // Comparación numérica por defecto
        if (valA < valB) return order === 'asc' ? -1 : 1;
        if (valA > valB) return order === 'asc' ? 1 : -1;
        return 0;
      });
      
    };
    
  const refresh_contractor_list = () => {
    async function fetchContractors() {
        const membersList = await get_contractor(token);
        if (membersList==="INVALID"){
          navigate("/");
        }else{

          const members = membersList.map((element, index) => {
            return {id:element.id,token:element.contractor_token , name: element.name, index: index };
          });

          setcontractors(members);
                  
       }
      }
      fetchContractors();
  }

  const selectContractor = (index, id) => {
      navigate("/contractor?id=" + id);
  };

  
  useEffect(() => {
    refresh_contractor_list();
  }, [token]); // Solo se vuelve a ejecutar si 'token' cambia


  
  const handleAddBt = () => {

 
    async function fetchAddModel(newProject) {
      
       
      const deviceMessages = await add_project(token, newProject);
      if (deviceMessages==="INVALID"){
        navigate("/");
      }else{
         refresh_contractor_list();

     }
    }

    fetchAddModel(modelInputRef.current.value);
  };


  return (
    
     <div className="container">
    
    <input
        type="text"
        placeholder="Buscar por nombre..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ marginBottom: '10px', padding: '5px', width: '100%' }}
      />
      <div className="table-container2">

    

      <table className="version-table2">
        <thead>
          <tr>
            <th style={{ width: '50%', cursor: 'pointer' }} onClick={() => sortTable('name')}>
              Nombre {sortedColumn === 'name' ? (sortOrder === 'asc' ? '🔼' : '🔽') : ''}
            </th>
           
            <th style={{ width: '15%' }}>Dashboard</th>
          </tr>
        </thead>
        <tbody>
          {filteredContractors.map((project, index) => (
            <tr
              key={index}
              onClick={permission === "1" ? () => selectContractor(index, project.token) : null}
            >
              <td>{project.name}</td>
              <td>
                <a
                  href={`https://lookerstudio.google.com/reporting/61c67766-8a5a-4394-863c-737a9f9ca2eb`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Dashboard
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    {permission === "1" ? 
              
              <div className='newProject'>

              <input  type="text" id="new_project" ref={modelInputRef} />
              <button onClick={handleAddBt}>Agregar</button>
              </div>
            : null}
    </div>
  );
};

export default Premium_services;
